
import { of as observableOf, Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { Yii } from "libraries/interfaces/Yii";

// Angular
import { Injectable } from '@angular/core';

// Lodash
import _set from 'lodash-es/set';

// Afidium
import { ApiService } from "libraries/service/api/api.service";

interface IDataDgeo {
    data: [
        {
            dgeo_id_geoentity: number;
            dgeo_name: string;
            dgeo_code_iata: string;
            dgeo_functions: string;
            dgeo_country_code: string;
            dgeo_country_name: string;
            cityref_id_geoentity: number;
            cityref_name: string;
            cityref_code_iata: string;
            dgeo_subdivision_code: number;
            search_column: string;
        }
    ];
}

export interface IFilterData {
    key: string;
    value: any;
    operator: string;
}

export interface ISearchResult {
    label: string;
    name?: string;
    id?: string;
    code: string;
    type: string;
    lat?: number;
    long?: number;
    country_code?: string;
}

/**
 * Autocompletion Service make a request to API for dynamic search
 */
@Injectable()
export class SearchService {
    constructor(private readonly apiService: ApiService) {
    }

    /**
     * @param {string} baseUrl Instance root
     * @param {string} queryArg Argument name
     * @param {string} term Term of research
     * @return Observable of IDataDgeo
     * Call ApiService and return observable of any
     * [ApiService]{@link ApiService#search}
     */
    public search(baseUrl: string, queryArg: string = '?query=', term: string): Observable<any> {
        return this.apiService.sendToApi(baseUrl, queryArg + term);
    }

    public formatData(data: any, format: string): any {
        return this[format](data);
    }


    /**
     * filter _data
     * §TODO : ability to use an array with _filterData
     * @param _filterData
     * @param _data
     * @returns {boolean}
     */
    public filterMe(_filterData: any, _data: any): boolean {
        let output: boolean = false;

        if (_filterData) {
            switch (_filterData.operator) {
                case "equal":
                    if (_data[_filterData.key] === _filterData.value) {
                        output = true;
                    }
                    break;
                case "diff":
                    if (_data[_filterData.key] !== _filterData.value) {
                        output = true;
                    }
                    break;
                case "sup":
                    if (_data[_filterData.key] > _filterData.value) {
                        output = true;
                    }
                    break;
                case "inf":
                    if (_data[_filterData.key] < _filterData.value) {
                        output = true;
                    }
                    break;
                default:
                    break;
            }
        } else {
            output = true;
        }

        return output;
    }

    public searchFormatFilter(_baseUrl: string, _term: string, _format: string, filter: IFilterData): Observable<any[]> {

        if (!_term) {
            return observableOf([]);
        }
        return this.search(_baseUrl, '?query=', _term).pipe(
            map((data: any) => data.data || []),
            map((data: any[]) => {
                return data.map((searchResult: any) => this.formatData(searchResult, _format))
                    .filter((formattedResult: any) => this.filterMe(filter, formattedResult));
            }));

    }

    private city(city: any) {

    }

    private location(_location: any): any {
        const tempLocation: any = {};

        const city: string = _location.cityref_name !== null ? _location.cityref_name : _location.dgeo_name;
        const country: string = _location.dgeo_country_name;
        const airport: string =
            _location.dgeo_functions === 'Airport' ? _location.dgeo_name : Yii.t('wui-shared-js', 'Tous aéroports');

        const label = city + ', ' + country + ": " + airport;
        _set(tempLocation, 'label', label);

        const id = _location.dgeo_id_geoentity;
        _set(tempLocation, 'id', id);

        const code = _location.dgeo_code_iata;
        _set(tempLocation, 'code', code);

        const type = _location.dgeo_functions;
        _set(tempLocation, 'type', type);

        _set(tempLocation, 'name', airport);

        return tempLocation;
    }

}
